package br.com.duoma.duomaproducao.model

import kotlinx.datetime.LocalDate


data class PartExecution(
    val date: LocalDate,
    val quantity: Int,
    val name: String,
    val order : Int,
    val lot : Int,
    val productionCell : String
) {
    fun identifier() = "$date $name $order $lot $productionCell"
}